export const pageMenuTabList01 = [
  { id: "tab01", url: "/introduction", text: "기업철학", on: false, col:4},
  { id: "tab02", url: "/history", text: "연 혁", on: false, col:4},
  { id: "tab03", url: "/manufacture", text: "제조설비", on: false, col:4 },
  { id: "tab04", url: "/location", text: "오시는 길", on: false, col:4 },
];

export const pageMenuTabList02 = [
  { id: "tab01", url: "/b2b", text: "사업소개", on: false, col:3},
  { id: "tab02", url: "/partners", text: "파트너사/대표제품", on: false, col:3},
  { id: "tab03", url: "/proposal", text: "OEM/ODM 문의", on: false, col:3 },
];

export const pageMenuTabList03 = [
  { id: "tab01", url: "/global", text: "해외사업현황", on: false, col:2},
  { id: "tab02", url: "/proposaloversea", text: "수출상담", on: false, col:2},
];

export const pageMenuTabList04 = [
  { id: "tab01", url: "/research", text: "연구개발/특허", on: false, col:3},
  { id: "tab02", url: "/qc", text: "품질인증", on: false, col:3},
  { id: "tab03", url: "/qs", text: "품질안전관리", on: false, col:3},
];

export const pageMenuTabList05 = [
  { id: "tab01", url: "/brand", text: "브랜드", on: false, col:3},  
  { id: "tab02", url: "/channel", text: "채널소개", on: false, col:3},
  { id: "tab03", url: "/store", text: "매장소개", on: false, col:3},
];

export const pageMenuTabList06 = [
  { id: "tab01", url: "/board/noticenews", text: "회사소식", on: false, col:2},
  { id: "tab02", url: "/board/notice", text: "공지사항", on: false, col:2},  
];
